import React from 'react'

export default function Helmet(props) {
    document.title = "PT2000 - " + props.title; 
    return <div >
        {props.children}
        
        </div>;
}
